import { render, staticRenderFns } from "./purchase_return_detail.vue?vue&type=template&id=6a71f1e9&scoped=true"
import script from "./purchase_return_detail.vue?vue&type=script&lang=js"
export * from "./purchase_return_detail.vue?vue&type=script&lang=js"
import style0 from "./purchase_return_detail.vue?vue&type=style&index=0&id=6a71f1e9&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a71f1e9",
  null
  
)

export default component.exports